import {performance} from './performanceClient';

export function buildDesktopAppLoadData() {
  if (!performance.timing) {
    return undefined;
  }

  return {
    startTime: performance.timing.navigationStart,
    appFetchDuration: performance.timing.responseEnd - performance.timing.navigationStart,
  };
}
